module.exports = __webpack_public_path__ + "static/img/dev5.8ba6bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/development/dev5.jpg
// module id = qDHC
// module chunks = 0